import React from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import { getAuth0Config } from '../config'

type Auth0ProviderWithHistoryProps = {
  children: React.ReactNode
}

const Auth0ProviderWithHistory: React.FC<Auth0ProviderWithHistoryProps> = (props) => {
  const config = getAuth0Config()

  return (
    <Auth0Provider
      domain={config.domain}
      clientId={config.client_id}
      authorizationParams={{
        audience: config.audience,
        redirect_uri: config.redirect,
      }}
      cacheLocation={config.cacheLocation}
    >
      {props.children}
    </Auth0Provider>
  )
}

export default Auth0ProviderWithHistory
